<template>
	<div class="product">
		<banner title="新闻资讯" :img="sty" />
		<div class="aboutus_selection">
			<div class="clearfix">
				<!-- <div :class="activeName == 'first' ? 'selected' : ''" @click="change('first')">
					<span>口岸分布</span>
				</div> -->
				<!-- <div :class="activeName == 'second' ? 'selected' : ''" @click="change('second')">
					<span>驳船服务</span>
				</div> -->
				<div :class="activeName == 'three' ? 'selected' : ''" @click="change('three')">
					<span>合作船公司</span>
				</div>
				<div :class="activeName == 'four' ? 'selected' : ''" @click="change('four')">
					<span>我们的服务</span>
				</div>
				<div :class="activeName == 'five' ? 'selected' : ''" @click="change('five')">
					<span>业务咨询</span>
				</div>
				<div @click="links">
					<span>&nbsp;&nbsp;海外物流</span>
				</div>
			</div>
		</div>
		<div style="position: relative;">
			<!-- <mapChina v-if="activeName == 'first'" /> -->
			<!-- <feature v-if="activeName == 'second'" /> -->
			<company v-if="activeName == 'three'" />
			<scopeView v-if="activeName == 'four'" />
			<phoneList v-if="activeName == 'five'" />
		</div>
		
		<!-- <el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane name="first">
				<span slot="label"><img class="title_img" :src="getImgUrl(first)" alt="" />
					口岸分布</span>
				<mapChina />
			</el-tab-pane>
			<el-tab-pane name="second">
				<span slot="label"><img class="title_img" :src="getImgUrl(second)" alt="" />
					驳船服务</span>
				<feature v-if="activeName == 'second'" />
			</el-tab-pane>
			<el-tab-pane name="three">
				<span slot="label"><img class="title_img" :src="getImgUrl(three)" alt="" />
					合作船公司</span>
				<company v-if="activeName == 'three'" />
			</el-tab-pane>
			<el-tab-pane name="four">
				<span slot="label"><img class="title_img" :src="getImgUrl(four)" alt="" />
					端到端服务</span>
				<scopeView v-if="activeName == 'four'" />
			</el-tab-pane>
			<el-tab-pane name="five">
				<span slot="label"><img class="title_img" :src="getImgUrl(five)" alt="" /> 通讯录</span>
				<phoneList v-if="activeName == 'five'" />
			</el-tab-pane>
		</el-tabs> -->
	</div>
</template>

<script>
	import Banner from "@/components/Banner";
	import mapChina from "@/views/serve/map.vue";
	import feature from "@/views/serve/feature.vue";
	import company from "@/views/serve/company.vue";
	import scopeView from "@/views/serve/scope.vue";
	import phoneList from "@/views/serve/phoneList.vue";

	export default {
		data() {
			return {
				sty: {
					// backgroundImage: "url(" + require("@/assets/home/banner2.png") + ")",
				},
				activeName: "three",
				first: "first1",
				second: "second1",
				three: "three1",
				four: "four1",
				five: "five1",
				titleLog: [{
					pic: "@/assets/navigation/first1",
					active: "",
				}, ],
			};
		},
		components: {
			Banner,
			mapChina,
			feature,
			company,
			scopeView,
			phoneList,
		},
		methods: {
			links() {
				window.open('http://cat.js-chinaarts.com/index.html#/login');
			},
			change(a){
				this.activeName = a;
			},
			getImgUrl(icon) {
				//展示图片
				return require(`@/assets/navigation/${icon}.png`);
			},
			handleClick(tab, event) {
				//切换图标
				let index = tab.name;
				sessionStorage.setItem("showServeIndex", index);
				let arr = ["first", "second", "three", "four", "five"];
				arr.forEach((item) => {
					if (item == index) {
						this[item] = item + "2";
					} else {
						this[item] = item + "1";
					}
				});
			},
			getlunbo() {
				var that = this;
				that
					.$axios({
						method: "get",
						url: "system/pcmanage/list",
						// data: this.$qs.stringify(data)
						params: {
							location: 4,
						},
					})
					.then((res) => {
						// console.log(JSON.stringify(res.data));
						// console.log(res.data.data);
						if (res.data.result == 200) {
							console.log(res.data);
							var data = res.data.detail;
							that.sty = {
								backgroundImage: "url(" + data[0].showpath + ")",
							};
						}
					});
			},
		},
		computed: {
			showIndex() {
				let index = sessionStorage.getItem("showServeIndex");
				return index;
			},
		},
		mounted() {
			this.getlunbo(); //轮播图

			this.activeName = this.showIndex || "three";
			if (this.$route.query.id && this.$route.query.id.length > 0) {
				this.activeName = this.$route.query.id;
			} else {
				if (this.showIndex && typeof this.showIndex == "string") {
					this[this.showIndex] = this.showIndex + "2";
				}
			}
		},
	};
</script>

<style lang="scss" scoped>
	.aboutus_selection {
		width: 100%;
	
		.clearfix {
			display: flex;
			width: 1000px;
			margin: auto;
			padding: 24px 0;
	
			div {
				// float: left;
				box-sizing: border-box;
				width: 33%;
				text-align: center;
				height: 24px;
				line-height: 24px;
				cursor: pointer;
				border-right: 1px solid #d2d2d2;
	
				span {
					display: inline-block;
					height: 18px;
					line-height: 18px;
					padding-left: 30px;
					color: #363636;
					font-size: 16px;
					background-repeat: no-repeat;
					background-position: left top;
					background-size: contain;
				}
			}
	
			div:last-child {
				border-right: none;
			}
	
			div.selected span {
				color: #0385ca;
			}
	
			div:nth-of-type(1) span {
				background-image: url(../assets/navigation/first1.png);
			}
	
			div:nth-of-type(1).selected span {
				background-image: url(../assets/navigation/first2.png);
			}
	
			div:nth-of-type(2) span {
				background-image: url(../assets/navigation/second1.png);
			}
	
			div:nth-of-type(2).selected span {
				background-image: url(../assets/navigation/second2.png);
			}
	
			div:nth-of-type(3) span {
				background-image: url(../assets/navigation/three1.png);
			}
	
			div:nth-of-type(3).selected span {
				background-image: url(../assets/navigation/three2.png);
			}
	
			div:nth-of-type(4) span {
				// background-image: url(../assets/navigation/four1.png);
				background-image: url(../assets/home/aic.jpg);
			}
	
			/* div:nth-of-type(4).selected span {
				background-image: url(../assets/navigation/four2.png);
			} */
	
			div:nth-of-type(5) span {
				background-image: url(../assets/navigation/five1.png);
			}
	
			div:nth-of-type(5).selected span {
				background-image: url(../assets/navigation/five2.png);
			}
		}
	}
	::v-deep.el-tabs__header {
		height: 70px;
		margin-bottom: 0;

		.el-tabs__nav-wrap {
			height: 70px;
			display: flex;
			justify-content: center;

			.el-tabs__nav-scroll {
				height: 70px;
				width: 70%;

				.el-tabs__nav {
					height: 70px;
					// width: 100%;
					line-height: 70px;
					display: flex;
					align-items: center;
					min-width: 1200px;

					.el-tabs__active-bar {
						display: none;
					}

					.el-tabs__item {
						width: 20%;
						height: 36px;
						line-height: 36px;
						border-left: 1px solid #e3e3e3;
						text-align: center;

						span {
							display: inline-block;
							height: 36px;
							line-height: 36px;
							font-size: 16px;

							.title_img {
								width: 20px;
								height: auto;
								margin-top: -1px;
								margin-right: 2px;
							}
						}
					}

					#tab-first {
						border-left: none;
					}
				}
			}
		}

		.el-tabs__nav-wrap::after {
			height: 0 !important;
			background-color: #fff;
		}
	}
</style>
